export default __webpack_public_path__ + "static/media/HT.57f2b23c.svg";